import React, { useMemo, useState, useEffect } from "react";
import { Box, ButtonGroup, Button, Text, Input, Select, HStack } from "@chakra-ui/react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

export default function Pagination(props) {
  const { inputArray, setTranscriptsToDisplay } = props;
  console.log({ props });

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(undefined);
  useEffect(() => {
    setCurrentPage(1);
  }, []);

  useEffect(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = inputArray.slice(indexOfFirstItem, indexOfLastItem);

    setTranscriptsToDisplay(currentItems);
  }, [inputArray, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [inputArray]);

  const totalPages = Math.ceil(inputArray.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      {/* {inputArray?.length ? (
        <Box className="pagination" m="10px" mt="20px" overflow={"scroll"}>
          <ButtonGroup spacing={2}>
            <Button
              size="sm"
              borderRadius="4px"
              bgColor={"#E2E8F0"}
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              <MdChevronLeft />
            </Button>
            {Array.from({ length: totalPages }).map((_, index) => (
              <Button
                key={index}
                size="sm"
                borderRadius="4px"
                bgColor={currentPage === index + 1 ? "#3182CE" : "#E2E8F0"}
                color={currentPage === index + 1 ? "white" : "black"}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Button>
            ))}
            <Button
              size="sm"
              borderRadius="4px"
              bgColor={"#E2E8F0"}
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              <MdChevronRight />
            </Button>
          </ButtonGroup>
        </Box>
      ) : null} */}

      <div className="pagination" style={{ margin: "25px 0px 0px 0px" }}>
        <HStack>
          <Button
            size="sm"
            onClick={() => {
              handlePageChange(1)
            }}
            disabled={currentPage === 1 ? true : false}
          >
            {"<<"}
          </Button>{" "}
          <Button
            size="sm"
            onClick={() => {
              handlePageChange(currentPage - 1);
            }}
            disabled={currentPage === 1 ? true : false}
          >
            {"<"}
          </Button>{" "}
          <Button size="sm" onClick={() => {
            handlePageChange(currentPage + 1);
          }}
            disabled={currentPage === totalPages ? true : false}
          >
            {">"}
          </Button>{" "}
          <Button
            size="sm"
            onClick={() => {
              handlePageChange(totalPages);
            }}
            disabled={currentPage === totalPages ? true : false}
          >
            {">>"}
          </Button>{" "}
          <Text fontSize="sm" style={{ width: "10em" }}>
            Page{" "}
            <strong>
              {currentPage} of {totalPages}
            </strong>{" "}
          </Text>
          <Text fontSize="sm">
            | Go to page:{" "}
            <Input
              type="number"
              // defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) : 0;
                handlePageChange(page);
              }}
              variant="filled"
              size="xs"
              width="20%"
            />
          </Text>

        </HStack>
      </div>
    </>
  );
}
